import React, { useState } from 'react';
import {
    Tab, Box,
} from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { defaultGuid } from '../../../common/utils'
import GenerateTopics from "../../components/topics/generateTopics";

const Index = ({ userRoles, companyId, companyName, selectedSubMenu }) => {
    const [tabValue, setTabValue] = useState(1);

    const isIRUser = React.useMemo(() => userRoles?.indexOf("IRUser") >= 0, [userRoles]);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }
    return (
        <>
            {isIRUser &&
                <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
                        <TabList onChange={handleTabChange}>
                            <Tab label="Standard" value={1} sx={{ textTransform: "none" }} />
                            <Tab label="Extract from Reviews" value={2} sx={{ textTransform: "none" }} />
                        </TabList>
                    </Box>
                </TabContext>
            }

            {selectedSubMenu === 10 && tabValue === 1 &&
                <GenerateTopics isInitialTopics={true} type="Business" userRoles={userRoles} companyId={defaultGuid} companyCompanyId={companyId} companyName={companyName} />
            }
            {selectedSubMenu === 10 && tabValue === 2 &&
                <GenerateTopics isInitialTopics={false} type="Topics" userRoles={userRoles} companyId={companyId} companyCompanyId={companyId} companyName={companyName} />
            }

        </>
    )
}

export default Index;